<template>
  <div class="loading-widget" :style="containerStyle" role="status" aria-live="polite">
    <div class="loading-widget__header">
      <div class="spinner-border text-primary loading-widget__spinner" role="presentation"></div>
      <div>
        <div class="loading-widget__title">{{ title }}</div>
        <p v-if="message" class="loading-widget__message">{{ message }}</p>
      </div>
    </div>
    <div class="loading-widget__skeleton" aria-hidden="true">
      <span v-for="line in lines" :key="line" class="loading-widget__line"
        :class="`loading-widget__line--${line % 3}`"></span>
    </div>
  </div>
</template>

<script>
import { logAnalyticsEvent } from '@/common/lib/firebase'

export default {
  name: 'LoadingComponent',
  props: {
    title: {
      type: String,
      default: 'Loading section'
    },
    message: {
      type: String,
      default: 'Please wait while content loads.'
    },
    minHeight: {
      type: [String, Number],
      default: 220
    },
    lines: {
      type: Number,
      default: 4
    }
  },
  computed: {
    containerStyle() {
      const minHeight = typeof this.minHeight === 'number' ? `${this.minHeight}px` : this.minHeight
      return { minHeight }
    }
  },
  mounted() {
    logAnalyticsEvent('loading_widget_shown', {
      line_count: this.lines,
      has_custom_title: this.title !== 'Loading section',
      has_custom_message: this.message !== 'Please wait while content loads.',
    })
  }
}
</script>

<style scoped>
.loading-widget {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 1.25rem;
  padding: 1.25rem 1.35rem;
  border: 1px solid #d8e1fb;
  border-radius: 14px;
  background: linear-gradient(180deg, #ffffff 0%, #f5f8ff 100%);
  box-shadow: 0 10px 24px rgba(0, 8, 87, 0.08);
}

.loading-widget__header {
  display: flex;
  align-items: center;
  gap: 0.9rem;
}

.loading-widget__spinner {
  width: 2rem;
  height: 2rem;
  flex: 0 0 auto;
}

.loading-widget__title {
  font-family: var(--font-heading);
  font-size: 1rem;
  color: var(--blue-dark);
}

.loading-widget__message {
  margin: 0.2rem 0 0;
  color: #5f6b85;
}

.loading-widget__skeleton {
  display: grid;
  gap: 0.7rem;
}

.loading-widget__line {
  display: block;
  height: 0.9rem;
  border-radius: 999px;
  background: linear-gradient(90deg, rgba(150, 161, 232, 0.16) 0%, rgba(150, 161, 232, 0.36) 50%, rgba(150, 161, 232, 0.16) 100%);
  background-size: 220% 100%;
  animation: loading-widget-shimmer 1.4s ease-in-out infinite;
}

.loading-widget__line--1 {
  width: 100%;
}

.loading-widget__line--2 {
  width: 82%;
}

.loading-widget__line--0 {
  width: 64%;
}

@keyframes loading-widget-shimmer {
  0% {
    background-position: 100% 0;
  }

  100% {
    background-position: -100% 0;
  }
}
</style>
